import React, { useState, useEffect, Fragment } from "react";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import i18n from '../i18n';
import Navbar from "../Navbar";
import Footer from "../Footer";
import 'aos/dist/aos.css';
import Aos from "aos";
import { config } from "../api/api";




function MotorInsuranceHome() {
  const base_url = config.baseURL;

  const lnstr = Cookies.get('langData') ? Cookies.get('langData') : 'en';


  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    insurancetype: '',
  });

  const [selectedOption, setSelectedOption] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showSection, setShowSection] = useState(false);

  const [buttonDisabled, setButtonDisabled] = useState(false);

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
    setFormData({ ...formData, 'insurancetype': event.target.value });

    if (event.target.value === ' ') {
      setShowSection(true);
      setButtonDisabled(true);
    }
    else {
      setShowSection(false);
      setButtonDisabled(false);
    }
  };

   useEffect(()=>{
      const planvalue = sessionStorage.getItem('motorplan');
      if(planvalue != undefined) {
        const plan = JSON.parse(planvalue)
        setSelectedOption(plan.plan)
      }
      sessionStorage.clear();
    },[])

  const handleSubmit = async (event) => {

    event.preventDefault();

    if (selectedOption === null) {
      alert('Please choose a plan');
      return false;
    }

    setLoading(true);

    // const postvData = { organization_name: "Superjet" };

    try {
      // // Create the organization
      // const response = await fetch( base_url + '/create_organization', {
      //   method: 'POST',
      //   headers: {
      //     'Content-Type': 'application/json',
      //   },
      //   body: JSON.stringify(postvData),
      // });

      // const data = await response.json();
      // const vendorKey = data.result[0].vendor_key;

      // // Set vendor key in cookie
      // Cookies.set('Vendorkey', vendorKey);

      // Check if the selected option is 'Personal Accident'
      if (selectedOption === 'New_Policy') {
       
        var plandata= {
          'plan':selectedOption
        }

        sessionStorage.clear();
        sessionStorage.setItem("motorplan" , JSON.stringify(plandata));


        
        // Redirect after token is set*/}
        
        window.location.href = '/dhofar-motorinsurance';
    
      } 
      else {

        const  plan_data= {
          'plan':selectedOption
        }
        sessionStorage.clear();

        sessionStorage.setItem("motorplan" , JSON.stringify(plan_data));
        
        // SessionRemove();

        window.location.href = '/motor-renew-policy';
        
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false); // Ensure loading state is reset
    }
  };


  return (
    <Fragment>

      <div className="header_section1">

        <Navbar />


        <div className="container-fluid bg-breadcrumb">
          <div className="container text-center py-5">
            <h3 className="abt-txt my-5">{(lnstr === 'en') ? 'Motor Insurance' : ''}</h3>
          </div>
        </div>

      </div>


      <div className="features_section">
        <div className="container">

          <div className="row">

            <Col md={3}></Col>

            <Col md={6} className="myforms my-5">



              <h4 className="px-0 py-2">{(lnstr === 'en') ? 'Choose Your Policy Type' : 'اختر نوع السياسة الخاصة بك\n'}</h4>

              <form onSubmit={handleSubmit}>

                <div class="align-items-center travel-selection-option">
                  {(lnstr === 'en') ? 'New Policy' : 'سياسة جديدة\n'}
                  <input type="radio" name="motorInsurance" value="New_Policy" 
                  checked={(selectedOption&&selectedOption==="New_Policy") ? true:false}
                  className="d-inline-block option-circle ml-auto" onChange={handleOptionChange}  />
                </div>

                <div class="align-items-center travel-selection-option my-3">
                  {(lnstr === 'en') ? 'Renew Policy' : 'تجديد السياسة\n'}
                  <input type="radio" name="motorInsurance" value="Renew_Policy"
                  checked={(selectedOption&&selectedOption==="Renew_Policy")?true:false}
                   className="d-inline-block option-circle ml-auto" onChange={handleOptionChange} />
                </div>



                <button type="submit" disabled={buttonDisabled} className="btn btn-primary rounded-pill text-white my-1 py-1 px-4">{t('Submit')}</button>

              </form>


            </Col>

            <Col md={3}></Col>

          </div>

        </div>
      </div>

      <Footer />

      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

    </Fragment>
  );
}

export default MotorInsuranceHome;
